module.exports = __webpack_public_path__ + "static/media/bitwolf.80b3b6fb.png";